import type { VectorCell, VectorKind } from "../mappers";
import { DASH } from "../format";
import { C, vectorColors } from "../theme";

export const VectorChip = ({
  cell,
  size = "sm",
}: {
  cell: VectorCell;
  size?: "sm" | "md";
}) => {
  const { bg, fg } = vectorColors[cell.kind];
  return (
    <span
      title={cell.label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
        width: size === "md" ? 18 : 13,
        height: size === "md" ? 18 : 16,
        borderRadius: 2,
        fontSize: 10,
        fontWeight: 700,
        background: bg,
        color: fg,
      }}
    >
      {cell.ch}
    </span>
  );
};

/** 24-month behaviour strip; the character is always shown, colour is secondary. */
export const BehaviourVector = ({ cells }: { cells: VectorCell[] }) => {
  if (cells.length === 0) return <>{DASH}</>;
  return (
    <div
      role="img"
      aria-label={`Comportamiento, más reciente primero: ${cells
        .map((c) => `${c.ch} ${c.label}`)
        .join(", ")}`}
      style={{ display: "flex", gap: 2 }}
    >
      {cells.map((c, i) => (
        <VectorChip key={i} cell={c} />
      ))}
    </div>
  );
};

const LEGEND: VectorCell[] = (
  [
    ["N", "ok", "Al día"],
    ["1", "m30", "Mora 30"],
    ["2", "m60", "Mora 60"],
    ["3", "m90", "Mora ≥ 90"],
    ["–", "none", "Sin info"],
  ] as [string, VectorKind, string][]
).map(([ch, kind, label]) => ({ ch, kind, label }));

export const VectorLegend = ({ caption }: { caption?: string }) => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      fontSize: 11,
      color: C.text,
      alignItems: "center",
    }}
  >
    {caption && <span>{caption}</span>}
    {LEGEND.map((c) => (
      <span
        key={c.kind}
        style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
      >
        <VectorChip cell={c} />
        {c.label}
      </span>
    ))}
  </div>
);
